import {getFlightDetails} from '@/lib/flight/flightService'
import {useLocale} from '@/lib/locale/locale'
import {NO_REFETCH_OPTIONS} from '@/utils/query/query'

export default function useFlightDetailsQuery(flightId: string) {
  const [locale] = useLocale()

  return useQuery({
    queryKey: ['flightDetails', locale, flightId],
    queryFn: async () => getFlightDetails({flightId, locale}),
    throwOnError: true,
    ...NO_REFETCH_OPTIONS,
  })
}
